import React, { useState, useEffect, useContext } from "react";
import "./transaction.scss";
import {FaCheckCircle,FaRegPlusSquare,FaRegMinusSquare} from 'react-icons/fa'
import WithAuthentication from "Authentication/AuthenticationContext";
import {
  TransferToCard,
  TransactionRecords,
  date,
  inventory,
  Charg,
} from "../../services/transactions.js";
import { showSwalError, showSwalSuccess } from "../../utilities/swal";

function Transa({ info }) {
    const [Date ,setDate] = useState("")

    useEffect(()=>{
      setDate(date(info.mtm));
    },[])

  return (
    <div
      className="d-flex flex-row px-3 py-3  my-3 mx-1"
      style={{
        border: "2px solid #A7A9D6",
        borderRadius: "10px",
        width: "48%",
      }}
    >
      <FaCheckCircle
        className="fs-3 me-2"
        style={{ color: "#303481", marginTop: "13px" }}
      />
      <div className="d-flex flex-column  justify-content-around w-100">
        <div className="d-flex flex-column justify-content-between flex-wrap my-3">
          {/* wallets_transactions */}

          {info.type == 0 ? (
            <>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>شارژ حساب</h5>
                </div>
                <div>
                  <h5>{info.wallet_id}</h5>
                </div>
              </div>
            </>
          ) : info.type == 1 ? (
            <>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>خرید از حساب</h5>
                </div>
                <div>
                  <h5>{info.from_wallet_id}</h5>
                </div>
              </div>
            </>
          ) : info.type == 2 ? (
            <>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>انتقال از حساب</h5>
                </div>
                <div>
                  <h5>{info.from_wallet_id}</h5>
                </div>
              </div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>به</h5>
                </div>
                <div>
                  <h5>{info.to_wallet_id}</h5>
                </div>
              </div>
            </>
          ) : info.type == 3 ? (
            <>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>برداشت از حساب</h5>
                </div>
                <div>
                  <h5>{info.from_wallet_id}</h5>
                </div>
              </div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>انتقال به شماره کارت</h5>
                </div>
                <div>
                  <h5>{info.tparams}</h5>
                </div>
              </div>
            </>
          ) : (
            null
          )}

          {/* 
            0=>شارژ
            1=>خرید
            2=>انتقال داخلی
            3=> برداشت
          */}
        </div>
        <div className="d-flex flex-row justify-content-between flex-wrap my-3">
          <h5>
            <span className="mx-3">{Date[2]}</span>
            {`${Date[0]}:${Date[1]}`}
          </h5>
          <h5>{info.amount.toLocaleString()} ریال</h5>
        </div>
      </div>
    </div>
  );
}

export default function Transactions() {
    const [style, setstyle] = useState([true,false])
    const [CostButton, setCostButton] = useState([false,false,false])
    const [costInput, setcostInput] = useState("0")
    const [Input1, setInput1] = useState("")
    const [Input2, setInput2] = useState("")
    const [records , setRecords]=useState([])
    const [update,setUpdate] = useState(true)
    const [current_inventor, setCurrent_inventor] = useState(true);
    const auth = useContext(WithAuthentication);

    

    useEffect(async() => {
      let array = await TransactionRecords((auth.userInfo.id));
      setRecords(array);
      let data = await inventory((auth.userInfo.id));
      setCurrent_inventor(data);
    }, [update]);

    const click = (TAB)=>{

        setstyle(style.map((value,index)=> {
           if (index==TAB) {
               return true
           }else {
               return false
           }
        }))

    }

    const clickCost = (TAB)=>{

        setCostButton(CostButton.map((value,index)=> {
           if (index==TAB) {
               return !value
           }else {
               return false
           }
        }))

    }

    const TransferTo = async (input1,input2)=>{
        if (input1=="" && input2=="") {
            showSwalError("\n مبلغ و شماره کارت را وارد کنید");
        }else {
          let data = await TransferToCard(
            input1,
            input2,
            parseInt(auth.userInfo.id)
          );
            if (data) {
              setUpdate(!update);
              showSwalSuccess("درخواست ارسال شد");
            }
        }
    }


    return (
      <div
        className="bg-white m-md-5 mt-md-0 m-0 rounded-3 mx-auto Transactions d-flex flex-column w-75"
        style={{ border: "1px solid gray" }}
      >
        <ul
          class="nav nav-pills m-3  w-75  mx-auto py-3 "
          id="pills-tab"
          role="tablist"
          style={{ borderBottom: "2px solid #303481" }}
        >
          <li class="nav-item mx-3 my-2" role="presentation">
            <a
              class="nav-link active btn border border-dark "
              onClick={() => click(0)}
              style={{ borderRadius: "10px" }}
              data-style={style[0]}
              id="buttonTAb1"
              data-bs-toggle="pill"
              data-bs-target="#Tab1"
              type="button"
              role="tab"
              aria-controls="pills-home"
              aria-selected="true"
            >
              تراکنش
            </a>
          </li>
          <li class="nav-item my-2" role="presentation">
            <a
              class="nav-link btn border border-dark me-2"
              onClick={() => click(1)}
              data-style={style[1]}
              style={{ borderRadius: "10px" }}
              id="buttonTAb2"
              data-bs-toggle="pill"
              data-bs-target="#Tab2"
              type="button"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
            >
              سوابق تراکنش
            </a>
          </li>
        </ul>

        <div class="tab-content  w-75 mx-auto " id="pills-tabContent">
          <div
            class="tab-pane fade show active div-Shadow"
            id="Tab1"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <div
              className="w-75 mx-auto pb-3 tabNumOne"
              style={{ borderBottom: "2px solid #303481" }}
            >
              <h5 className="text-center my-4">شارژ کیف پول</h5>
              <h5>موجودی فعلی: {current_inventor} ریال</h5>

              <div
                class="btn-group   d-flex flex-row justify-content-between flex-wrap w-75 mx-auto my-4"
                role="group"
                aria-label="Basic checkbox toggle button group"
              >
                <button
                  onClick={() => {
                    clickCost(0) || CostButton[0]
                      ? setcostInput(0)
                      : setcostInput(3000000);
                  }}
                  className="btn btn-outline-secondary m-2 rounded cost-width"
                  style={{
                    backgroundColor: CostButton[0] && "gray",
                    color: CostButton[0] && "white",
                  }}
                >
                  3000,000 ریال
                </button>
                <button
                  onClick={() => {
                    clickCost(1) || CostButton[1]
                      ? setcostInput(0)
                      : setcostInput(2000000);
                  }}
                  className="btn btn-outline-secondary m-2 rounded cost-width"
                  style={{
                    backgroundColor: CostButton[1] && "gray",
                    color: CostButton[1] && "white",
                  }}
                >
                  2000,000 ریال
                </button>
                <button
                  onClick={() => {
                    clickCost(2) || CostButton[2]
                      ? setcostInput(0)
                      : setcostInput(500000);
                  }}
                  className="btn btn-outline-secondary m-2 rounded cost-width"
                  style={{
                    backgroundColor: CostButton[2] && "gray",
                    color: CostButton[2] && "white",
                  }}
                >
                  500,000 ریال
                </button>
              </div>

              <div
                className="text-center d-flex flex-row mx-auto my-3"
                style={{ width: "170px", height: 34 }}
              >
                <button
                  className="btn border-none shadow-none p-0"
                  style={{ width: "fit-content" }}
                  onClick={() =>
                    setcostInput(parseInt(costInput) + 10000) || clickCost(-1)
                  }
                >
                  <FaRegPlusSquare style={{ width: "20px" }} className="fs-2" />
                </button>
                <input
                  style={{ width: "117px" }}
                  value={costInput}
                  onChange={(e) =>
                    setcostInput(e.target.value) || clickCost(-1)
                  }
                  type={"number"}
                  className={` mx-1 ${costInput == "" ? "border-0" : "border"}`}
                  placeholder="مبلغ های دیگر"
                />
                <button
                  className="btn border-none shadow-none p-0"
                  style={{ width: "fit-content" }}
                  onClick={() =>
                    costInput > 0
                      ? setcostInput(parseInt(costInput) - 10000) ||
                        clickCost(-1)
                      : null
                  }
                >
                  <FaRegMinusSquare
                    style={{ width: "20px" }}
                    className="fs-2"
                  />
                </button>
              </div>
              <div className="text-end">
                <button
                  type="button"
                  className="btn text-white border-3 border-light but-width"
                  style={{
                    backgroundColor: "#8A3FFC",
                    borderRadius: "10px",
                    padding: "12px 90px",
                  }}
                  onClick={() => Charg(costInput)}
                >
                  پرداخت
                </button>
              </div>
            </div>
            <div className="w-75 mx-auto pb-5 tabNumOne">
              <h5 className="text-center my-4">انتقال به کارت</h5>
              <div className="d-flex flex-row w-100 justify-content-around flex-wrap">
                <div className="input-width">
                  <label className="form-label mb-4" for="cart">
                    شماره کارت مقصد را ارسال کنید
                  </label>
                  <div className=" position-relative mb-5">
                    <input
                      type="number"
                      dir="ltr"
                      id="cart"
                      value={Input1}
                      className="form-control h-25 inputs"
                      onChange={(e) => setInput1(e.target.value)}
                      style={{ width: "260px" }}
                    />
                    <span
                      className="position-absolute bg-white p-1 lablel"
                      style={{ top: "-18px", fontSize: "15px", right: "10px" }}
                    >
                      شماره کارت
                    </span>
                  </div>
                </div>

                <div className="input-width">
                  <label className="form-label mb-4" for="cost">
                    مبلغ انتقال را وارد کنید
                  </label>
                  <div className=" position-relative">
                    <input
                      type="number"
                      dir="ltr"
                      id="cost"
                      value={Input2}
                      className="form-control h-25 inputs"
                      onChange={(e) => setInput2(e.target.value)}
                      style={{ width: "260px" }}
                    />
                    <span
                      className="position-absolute bg-white p-1 lablel"
                      style={{ top: "-20px", fontSize: "15px", right: "10px" }}
                    >
                      مبلغ
                    </span>
                  </div>
                </div>
              </div>

              <div className="text-end">
                <button
                  type="button"
                  onClick={() => {
                    TransferTo(Input1, Input2);
                  }}
                  className="btn text-white border-3 border-light mt-3 but-width"
                  style={{
                    backgroundColor: "#8A3FFC",
                    borderRadius: "10px",
                    padding: "12px 100px",
                  }}
                >
                  ثبت
                </button>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade div-Shadow "
            id="Tab2"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
          >
            <div className="d-flex flex-wrap justify-content-between">
              {records && records.map((item, index) => (
                    <Transa key={index} info={item} />
                  ))}
            </div>
          </div>
        </div>
      </div>
    );
}